import React, { forwardRef, useContext, useState } from "react";
import PropTypes from "prop-types";
import { LpgConfirmOutline } from "@/icons";

import { useUniqueId } from "../hooks/useUniqueId";
import { ThemeContext } from "../Theme";
import { Icon } from "../Icon";

import CheckboxGroup from "../Checkbox/CheckboxGroup";
import CheckboxLegend from "../Checkbox/CheckboxLegend";

import styles from "./GlobalFooterCheckbox.scss";

const GlobalFooterCheckbox = forwardRef((props, ref) => {
  const {
    children,
    value,
    onChange,
    disabled,
    isValid,
    checked: initialChecked,
    ...restProps
  } = props;
  const context = useContext(ThemeContext);
  const [checked, setChecked] = useState(initialChecked);
  const { id, name } = restProps;
  const checkboxId =
    id || `footer-checkbox-${useUniqueId("GlobalFooter.Checkbox", props) + 1}`;
  const checkboxName = name || checkboxId;

  const onInputChange = (event) => {
    setChecked(event.target.checked);
    if (onChange) {
      onChange(event.target.value);
    }
  };

  let theme = "";
  if (context) {
    theme += ` ${styles[context]}`;
  }

  return (
    <label
      ref={ref}
      className={`${styles.checkbox} ${theme} ${disabled ? "is-disabled" : ""}`}
      htmlFor={checkboxId}
    >
      <input
        id={checkboxId}
        name={checkboxName}
        value={value}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onInputChange}
        className={`input ${!isValid ? "is-invalid" : ""}`}
        aria-invalid={!isValid}
        {...restProps}
      />
      <span className={styles.ci} aria-hidden="true">
        <span className={styles.icon}>
          <Icon
            icon={LpgConfirmOutline}
            size={Icon.Size.parent}
            focusable="false"
          />
        </span>
      </span>
      <span className={styles.ciLabel}>{children}</span>
    </label>
  );
});

GlobalFooterCheckbox.propTypes = {
  value: PropTypes.string,
  isValid: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

GlobalFooterCheckbox.defaultProps = {
  value: "",
  isValid: true,
  checked: false,
  disabled: false,
  onChange: () => {},
};

GlobalFooterCheckbox.CheckboxGroup = CheckboxGroup;
GlobalFooterCheckbox.CheckboxLegend = CheckboxLegend;

GlobalFooterCheckbox.displayName = "GlobalFooter.Checkbox";

export default GlobalFooterCheckbox;
